import { el } from '../core/dom.js';

export interface InsightCardData {
  /** Stable id so the card can be dismissed/marked seen later. */
  id: string;
  kind: 'win' | 'pattern' | 'next_action' | 'low_data' | 'bad_week' | 'safety';
  headline: string;
  evidence?: string;
  primary?: { label: string; onClick: () => void };
}

export function renderInsightCard(card: InsightCardData): HTMLElement {
  const borderColor = card.kind === 'safety' ? 'var(--danger)'
    : card.kind === 'bad_week' ? 'var(--warn)'
    : card.kind === 'win' ? 'var(--ok)'
    : 'var(--accent-soft)';
  const root = el('section', {
    class: `card insight-card insight-card--${card.kind}`,
    attrs: { 'aria-label': card.headline, style: `border-color:${borderColor};` },
  });
  root.appendChild(el('h2', { class: 'insight-card__headline' }, card.headline));
  if (card.evidence) {
    root.appendChild(el('p', { class: 'muted insight-card__evidence' }, card.evidence));
  }
  if (card.primary) {
    root.appendChild(el('button', {
      class: 'btn small insight-card__cta', attrs: { type: 'button' },
      onclick: () => card.primary?.onClick(),
    }, card.primary.label));
  }
  return root;
}
